<template>
  <v-form ref="form">
    <v-card class="mx-auto my-10" max-width="640">
      <v-card-title>
        <h2>Dashboarders Mistakes Report</h2>
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedCampaign"
          :items="campaigns"
          label="Campaigns"
          multiple
          chips
          prepend-icon="mdi-domain"
        ></v-autocomplete>
        <v-autocomplete
          v-model="selectedDashboarder"
          :items="dashboarderIds"
          label="Dashboarder Ids"
          multiple
          chips
          prepend-icon="mdi-account"
        ></v-autocomplete>
        <v-autocomplete
          v-model="selectedMistakeReason"
          :items="mistakeReasons"
          label="Mistake Reasons"
          multiple
          chips
          prepend-icon="mdi-book-cancel"
        ></v-autocomplete>
        <div class="d-flex">
          <date-picker required icon="mdi-calendar" label="Start Date" v-model="startDate" writable></date-picker>
          <date-picker required icon="mdi-calendar" label="End Date" v-model="endDate" writable></date-picker>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" :loading="isLoading" text @click="_downloadMistakeReport">
          <v-icon>mdi-download</v-icon>Download Data
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import DatePicker from "../components/DatePicker.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      campaigns: ['all'],
      mistakeReasons: ['all'],
      dashboarderIds: ['all'],
      selectedCampaign: "",
      selectedDashboarder: "",
      selectedMistakeReason: "",
      startDate: "",
      endDate: "",
      isLoading: false,
    };
  },
  components: {
    DatePicker
  },
  computed: {
    ...mapGetters(["selectedDashboard"]),
  },
  methods: {
    ...mapActions(["snackAlert", "mistakeInputs", "downloadMistakeReport"]),
    async _downloadMistakeReport () {
      if (!Date.parse(this.startDate) || !Date.parse(this.endDate)) {
        this.snackAlert({
          message: "Please select start and end date",
          color: "error",
        });
        return;
      }

      const data = {
        campaigns: !this.selectedCampaign ? "all" : this.selectedCampaign.includes("all") ? "all" : this.selectedCampaign,
        dashboarderIds: !this.selectedDashboarder ? "all" : this.selectedDashboarder.includes("all") ? "all" : this.selectedDashboarder,
        mistakeReasons: !this.selectedMistakeReason ? "all" : this.selectedMistakeReason.includes("all") ? "all" : this.selectedMistakeReason,
        from: `${this.formatDate(this.startDate)}`,
        to: `${this.formatDate(this.endDate, true)}`,
      };

      try {
        this.isLoading = true;
        const response = await this.downloadMistakeReport({ data, dashboard: this.selectedDashboard });
        // Parse to see if there is an error message
        if (response.message && !response.response) {
          this.isLoading = false;
          this.snackAlert({
            message: "The data seems to be empty",
            color: "error",
          });
          return;
        }
        this.downloadCSV(response);
        this.isLoading = false;
      } catch (error) {
        console.error("Failed to download data", error);
        this.isLoading = false;
        this.snackAlert({
          message: "Failed to download data",
          color: "error",
        });
      }
    },
    downloadCSV(csvData) {
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'data.csv';
      link.click();
    },
    formatDate(date, isEndDate = false) {
      const temp = new Date(date);
      if (isEndDate) {
        temp.setDate(temp.getDate() + 1); // Add one day for end date
        return moment(temp).format("YYYY-MM-DD");
      }
      return moment(temp).format("YYYY-MM-DD");
    },
  },
  async mounted() {
    try {
      this.isLoading = true;
      const response = await this.mistakeInputs({ dashboard: this.selectedDashboard });
      this.campaigns.push(...response.campaignIds);
      this.dashboarderIds.push(...response.dashboardIds);
      
      // Reasons is one object keys as reason and value as the message
      this.mistakeReasons = [...this.mistakeReasons, ...Object.keys(response.reasons)];

      this.isLoading = false;
    } catch (error) {
      console.error("Failed to fetch user inputs data", error);
      this.isLoading = false;
      this.snackAlert({
        message: "Failed to fetch data",
        color: "error",
      });
    }
  }
};
</script>